export const BASE_API_URL =
  process.env?.REACT_APP_BASE_API_URL ?? 'https://api.dev.qnous.io/api';

export const API_DOCS_URL = BASE_API_URL.replace(
  /\/api$/,
  '/testing/3c9a30c6-437e-4fd5-bdf8-3b64d82362ca/docs-json',
);

export const PDF_API_URL =
  process.env?.REACT_APP_PDF_API_URL ?? 'https://pdf.solution.qnous.io';

export const AWS_ASSETS_URL = 'https://cdn.solution.qnous.io/organization-logo';

export const isQH = window.location.hostname.includes('qh.qnous.io');
export const isLocal = window.location.hostname.includes('localhost');
export const originUrl = isLocal
  ? 'https://dev.qnous.io'
  : window.location.origin;

export const UsablePdfWidth = 680; // A4 width - 80px padding on both sides
